import {
    PerFilterState,
    State,
    initialState,
    perFilterInitialState,
} from "@/mk2/apps/bazaar/containers/BazaarGrid/BazaarGrid.reducers";
import { hashFilter } from "@/mk2/apps/bazaar/helpers/filter";
import { AppState } from "@/mk2/reducers";
import { Filter } from "@/mk/bazaar/product/filter/filterUtils";

export const getBazaarGridState = (state: AppState): State =>
    state.containers.bazaar.bazaarGrid || initialState;

export const getBazaarGridFilterState = (state: AppState, filter: Filter): PerFilterState =>
    getBazaarGridState(state).filters[hashFilter(filter)] || perFilterInitialState;
